'use client';

import React, { useState, useEffect } from 'react';
import { CircularProgress } from '../CircularProgress';
import { generateLoadingMessage } from 'utils/loadingMessages';

const PulseLoading = () => {
  const [message, setMessage] = useState(generateLoadingMessage());

  useEffect(() => {
    const changeTimer = setTimeout(() => {
      setMessage(generateLoadingMessage());
    }, 2500);

    return () => {
      clearTimeout(changeTimer);
    };
  }, [message]);

  return (
    <div
      className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-white/50 backdrop-blur-sm z-30"
      data-testid="trends-loading-overlay"
    >
      <CircularProgress size="sm" color="neutral" />
      <div className="text-sm font-semibold font-['Inter']">
        {message.split('').map((char, index) => (
          <span
            key={`${message}-${index}`}
            className="inline-block opacity-0 animate-fade-in bg-gradient-to-r from-sky-900 to-sky-800 bg-clip-text text-transparent"
            style={{
              animationDelay: `${index * 0.05}s`,
              animationFillMode: 'forwards',
            }}
          >
            {char === ' ' ? '\u00A0' : char}
          </span>
        ))}
      </div>
    </div>
  );
};

export default PulseLoading;
